import React, { memo } from "react";
import { HappycoWorkOrderFragment } from "gql/graphql";
import colors from "app/colors";
import { Text } from "@chakra-ui/react";
import useHappyco from "./use-happyco";

interface IProps {
  happycoWorkOrder: HappycoWorkOrderFragment;
}

const HappycoWorkOrderLocation = ({ happycoWorkOrder }: IProps) => {
  const { location } = useHappyco({ happycoWorkOrder });

  return (
    <Text
      fontSize={14}
      fontFamily="Outfit"
      noOfLines={1}
      fontWeight={700}
      color={colors.blackSecondary}
    >
      {location}
    </Text>
  );
};

export default memo(HappycoWorkOrderLocation);
